import { render, staticRenderFns } from "./two-column-no-footer.vue?vue&type=template&id=7c613144&"
import script from "./two-column-no-footer.vue?vue&type=script&lang=ts&"
export * from "./two-column-no-footer.vue?vue&type=script&lang=ts&"
import style0 from "./two-column-no-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports